import { render, staticRenderFns } from "./MarkExampapers.vue?vue&type=template&id=5a127ad6&scoped=true"
import script from "./MarkExampapers.vue?vue&type=script&lang=js"
export * from "./MarkExampapers.vue?vue&type=script&lang=js"
import style0 from "./MarkExampapers.vue?vue&type=style&index=0&id=5a127ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a127ad6",
  null
  
)

export default component.exports